import React from "react";
import { Container, Image } from "react-bootstrap";
import img from "../../Images/under-construction.png";

export default function NotAvailable() {
  return (
    <Container fluid="md" className="d-flex p-2 justify-content-center">
      <Image className="justify-content-center" fluid width={"25%"} src={img} />
    </Container>
  );
}
